/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Audio_Extraction_CompleteInputs */



/**
* | output |
* | --- |
* | "Audio extraction complete." |
*
* @param {Media_Import_Audio_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_audio_extraction_complete = /** @type {((inputs?: Media_Import_Audio_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Audio_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction audio terminee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioextraktion abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione audio completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение аудио завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracción de audio completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频提取完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの抽出が完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो निष्कर्षण पूर्ण हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extração de áudio concluída.")
	return /** @type {LocalizedString} */ ("Audio extraction complete.")
});